import { Controller } from "@hotwired/stimulus"
import { createClearButton } from "../helpers/clear_button"

// Adds/removes a clear (X) button inside a search input based on the current value.
// Works even when the filter bar uses data-turbo-permanent.
export default class extends Controller {
  connect() {
    this._bound = () => this._updateBtn()
    this.element.addEventListener("input", this._bound)
    // Run immediately to handle pre-filled values
    this._updateBtn()
  }

  _updateBtn() {
    const val = (this.element.value || "").trim()
    const wrapper = this.element.closest(".search-wrapper")
    if (!wrapper) return

    let btn = wrapper.querySelector(".search-clear-btn")

    if (val.length > 0) {
      this.element.style.paddingRight = "2rem"
      if (!btn) {
        btn = createClearButton({
          title: "Limpar busca",
          onClear: () => {
            this.element.value = ""
            this.element.dispatchEvent(new Event("input", { bubbles: true }))
            this.element.dispatchEvent(new Event("change", { bubbles: true }))
            const form = this.element.closest("form")
            if (form) form.requestSubmit()
            this._updateBtn()
          }
        })
        
        // Add specific positioning classes/styles for this context
        btn.classList.add("search-clear-btn")
        btn.style.position = "absolute"
        btn.style.right = "6px"
        btn.style.top = "0"
        btn.style.bottom = "0"
        btn.style.margin = "auto"
        btn.style.zIndex = "10"
        
        wrapper.appendChild(btn)
      }
    } else {
      this.element.style.paddingRight = ""
      if (btn) btn.remove()
    }
  }

  disconnect() {
    if (this._bound) this.element.removeEventListener("input", this._bound)
  }
}
